import script from "./Checkbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./Checkbox.vue?vue&type=script&lang=ts&setup=true"

import "./Checkbox.vue?vue&type=style&index=0&id=26bf4835&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26bf4835"]])

export default __exports__